import { SUBSCRIPTION_TYPE } from 'constants/salesConstants';
import moment from 'moment';

const subscriptionTypePropMap = {
  [SUBSCRIPTION_TYPE.ALL]: 'total',
  [SUBSCRIPTION_TYPE.MONTHLY]: 'mrr',
  [SUBSCRIPTION_TYPE.ANNUALLY]: 'arr',
};

const refundPropMap = {
  true: 'with_refunds',
  false: 'without_refunds',
};

const getCategoryLabel = (mDate, index) => {
  if (index === 0 || mDate.month() === 0) {
    return [mDate.format('MMM'), mDate.format('YYYY')];
  }

  return mDate.format('MMM');
};

export const mapMonthlyUsersChartData = (monthlyUsersData, settings) => {
  if (!monthlyUsersData?.months?.length || !settings) {
    return null;
  }

  const subscriptionTypeProp =
    subscriptionTypePropMap[settings.subscriptionType];
  const refundProp = refundPropMap[settings.withRefunds];

  const newUsersData = [];
  const returningUsersData = [];
  const monthlyPayingUsersData = [];
  const annuallyPayingUsersData = [];
  const xAxisCategories = [];
  const dates = [];

  monthlyUsersData.months.forEach((monthRow, index) => {
    const breakdown = monthRow[subscriptionTypeProp];
    const mrrBreakdown = monthRow.mrr;
    const arrBreakdown = monthRow.arr;

    newUsersData.push(breakdown?.[`new_${refundProp}`] || 0);
    returningUsersData.push(breakdown?.[`returning_${refundProp}`] || 0);
    monthlyPayingUsersData.push(mrrBreakdown?.[`paying_${refundProp}`] || 0);
    annuallyPayingUsersData.push(arrBreakdown?.[`paying_${refundProp}`] || 0);

    const date = moment({
      year: monthRow.month.year,
      month: monthRow.month.month - 1,
      day: monthRow.month.day,
    });

    dates.push(date);
    xAxisCategories.push(getCategoryLabel(date, index));
  });

  return {
    newUsersData,
    returningUsersData,
    monthlyPayingUsersData,
    annuallyPayingUsersData,
    xAxisCategories,
    dates,
  };
};
